import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import bannerImg from "../assets/images/galleryim.png";

import galleryVideo1 from "../assets/Videos/galleryvideo.mp4";

import gimg1 from "../assets/images/gimg1.jpeg";
import gimg2 from "../assets/images/gimg2.jpeg";
import gimg3 from "../assets/images/gimg3.jpeg";
import gimg4 from "../assets/images/gimg4.jpeg";
import gimg5 from "../assets/images/gimg5.jpeg";
import gimg6 from "../assets/images/gimg6.jpeg";
import gimg7 from "../assets/images/gimg7.jpeg";

const Gallery = () => {
  const [activePhase, setActivePhase] = useState(1);
  const customerdata = useSelector((store) => store.userReducer.customerdata);
  const navigate = useNavigate();
  const isLoggedIn = Boolean(customerdata?.token);

  const galleryRef = useRef(null);

  // =========================================
  // MOBILE ARROW STATES
  // =========================================

  const [showLeftArrow, setShowLeftArrow] = useState(false);
  const [showRightArrow, setShowRightArrow] = useState(true);

  const galleryItems = [
    { type: "image", src: gimg1 },
    { type: "image", src: gimg2 },
    { type: "video", src: galleryVideo1 },
    { type: "image", src: gimg3 },
    { type: "image", src: gimg4 },
    { type: "image", src: gimg5 },
    { type: "image", src: gimg6 },
    { type: "image", src: gimg7 },
  ];

  // =========================================
  // CHECK MOBILE SLIDER POSITION
  // =========================================

  useEffect(() => {
    const slider = galleryRef.current;

    if (!slider) return;

    const handleScroll = () => {
      if (window.innerWidth > 768) return;

      setShowLeftArrow(slider.scrollLeft > 5);

      setShowRightArrow(
        slider.scrollLeft + slider.clientWidth <
          slider.scrollWidth - 5
      );
    };

    slider.addEventListener("scroll", handleScroll);

    handleScroll();

    return () => {
      slider.removeEventListener("scroll", handleScroll);
    };
  }, []);

  // =========================================
  // MOBILE AUTO SLIDER
  // =========================================

  useEffect(() => {
    const slider = galleryRef.current;

    if (!slider) return;

    const autoSlide = setInterval(() => {
      if (window.innerWidth <= 768) {
        const card = slider.querySelector(
          ".new-gallery-page-image-card"
        );

        if (!card) return;

        const cardWidth = card.offsetWidth;
        const gap = 15;
        const scrollAmount = cardWidth + gap;

        const isLastSlide =
          slider.scrollLeft + slider.clientWidth >=
          slider.scrollWidth - 5;

        if (isLastSlide) {
          slider.scrollTo({
            left: 0,
            behavior: "smooth",
          });
        } else {
          slider.scrollBy({
            left: scrollAmount,
            behavior: "smooth",
          });
        }
      }
    }, 3000);

    return () => clearInterval(autoSlide);
  }, []);

  // =========================================
  // ARROW SCROLL
  // =========================================

  const scrollGallery = (direction) => {
    const slider = galleryRef.current;

    if (!slider) return;

    const card = slider.querySelector(
      ".new-gallery-page-image-card"
    );

    if (!card) return;

    const cardWidth = card.offsetWidth;
    const gap = 15;
    const scrollAmount = cardWidth + gap;

    slider.scrollBy({
      left:
        direction === "left"
          ? -scrollAmount
          : scrollAmount,
      behavior: "smooth",
    });
  };

  return (
    <div className="new-gallery-page">

      {/* ================================
          GALLERY BANNER
      ================================= */}

      <section className="home-main-sec kids-story-banner">

        <img
          src={bannerImg}
          className="home-main-sec-bg"
          alt="Gallery Banner"
        />

        <div className="home-main-sec-overlay"></div>

        <div className="container home-main-sec-content">

          <h1 className="loop-title">
            Memories Captured, Happiness Shared
          </h1>

        </div>

      </section>


      {/* ================================
          GALLERY CONTENT
      ================================= */}

      <section className="new-gallery-page-section">

        <div className="new-gallery-page-container">

          {/* ================================
              PHASE BUTTONS
          ================================= */}

          <div className="new-gallery-page-phase-buttons">

            <button
              type="button"
              className={`new-gallery-page-phase-button ${
                activePhase === 1
                  ? "new-gallery-page-phase-active"
                  : ""
              }`}
              onClick={() => setActivePhase(1)}
            >
              Phase 1
            </button>

            <button
              type="button"
              className={`new-gallery-page-phase-button ${
                activePhase === 2
                  ? "new-gallery-page-phase-active"
                  : ""
              }`}
              onClick={() => setActivePhase(2)}
            >
              Phase 2
            </button>

          </div>


          {/* ================================
              PHASE 1
          ================================= */}

          {activePhase === 1 && (

            <div className="new-gallery-page-phase-content">

              <p className="new-gallery-page-phase-title">
                In Association with Our Corporate Partner, ConsultHagnos
              </p>


              {/* ================================
                  GALLERY SLIDER
              ================================= */}

              <div className="new-gallery-page-slider-wrapper">

                {/* LEFT ARROW */}

                {showLeftArrow && (
                  <button
                    type="button"
                    className="new-gallery-page-arrow new-gallery-page-arrow-left"
                    onClick={() => scrollGallery("left")}
                    aria-label="Previous gallery image"
                  >
                    &#10094;
                  </button>
                )}


                {/* GALLERY */}

                <div
                  className="new-gallery-page-grid"
                  ref={galleryRef}
                >

                  {galleryItems.map((item, index) => (

                    <div
                      className="new-gallery-page-image-card"
                      key={index}
                    >

                      {item.type === "image" ? (

                        <img
                          src={item.src}
                          alt={`Gallery ${index + 1}`}
                          className="new-gallery-page-image"
                        />

                      ) : (

                        <video
                          src={item.src}
                          className="new-gallery-page-video"
                          autoPlay
                          muted
                          loop
                          playsInline
                        />

                      )}

                    </div>

                  ))}

                </div>


                {/* RIGHT ARROW */}

                {showRightArrow && (
                  <button
                    type="button"
                    className="new-gallery-page-arrow new-gallery-page-arrow-right"
                    onClick={() => scrollGallery("right")}
                    aria-label="Next gallery image"
                  >
                    &#10095;
                  </button>
                )}

              </div>

            </div>

          )}


          {/* ================================
              PHASE 2
          ================================= */}

          {activePhase === 2 && (

            <div className="new-gallery-page-phase-two">

              {isLoggedIn ? (
                <p className="new-gallery-page-phase-two-text">
                  Be a Part of the Journey
                </p>
              ) : (
                <button
                  type="button"
                  className="new-gallery-page-phase-two-text new-gallery-page-register-link"
                  onClick={() => navigate("/register")}
                >
                  Be a Part of the Journey — Register Now
                </button>
              )}

            </div>

          )}

        </div>

      </section>

    </div>
  );
};

export default Gallery;
